"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vaultingFixedFees = exports.vaultingRelativeFees = void 0;
/**
 * Values that are undefined will be replaced by the default "non-vaulting/recurring" values.
 * Ultimately, the values should all be defined from real transaction data.
 */
// denominated in %
exports.vaultingRelativeFees = {
    US: {
        SANDBOX: 2.59,
        PRODUCTION: undefined,
    },
    GB: {
        SANDBOX: 1.2,
        PRODUCTION: 1.2,
    },
    AU: {
        SANDBOX: 1.75,
        PRODUCTION: undefined,
    },
    CA: {
        SANDBOX: 2.7,
        PRODUCTION: 2.7,
    },
    IE: {
        SANDBOX: 1.2,
        PRODUCTION: 1.2,
    },
};
exports.vaultingFixedFees = {
    US: {
        // USD
        SANDBOX: 0.49,
        PRODUCTION: undefined,
    },
    GB: {
        // GBP
        SANDBOX: 0.3,
        PRODUCTION: 0.3,
    },
    AU: {
        // AUD
        SANDBOX: 0.3,
        PRODUCTION: undefined,
    },
    CA: {
        // CAD
        SANDBOX: 0.3,
        PRODUCTION: undefined,
    },
    IE: {
        // EUR
        SANDBOX: undefined,
        PRODUCTION: undefined,
    },
};
//# sourceMappingURL=payPalVaultingFees.js.map